const Home1 = {
    text: 'Home',
    link: '/consumer/home',
    icon: 'icon-home'
};
const Home = {
    text: 'Home',
    link: '/consumer/home',
    icon: 'icon-home'
};

const Dashboard = {
    text: 'Dashboard',
    link: '/consumer/home',
    icon: 'icon-speedometer'

};

// const ViewResponse = {
//     link: '/subscribers',

//     icon: 'fa fas fa-users',
//     //icon: 'user-friends',
// };

// const ViewReport = {
//      link: '/manageProperties',
//     icon: 'icon-grid'
// };
const ViewRequest = {
    text: 'View Request',
    link: '/consumer/viewrequest',

    icon: 'fa fas fa-users',
    // icon: 'user-friends'
};

const RequestDisclosure = {
    text: 'Request Disclosure',
     link: '/consumer/senddisclosure',
    icon: 'icon-grid'
};
const RequestDispute = {
    text: 'Request Dispute',
     link: '/consumer/senddispute',
    icon: 'icon-grid'
};

const headingMain = {
    text: 'Main Navigation',
    heading: true
};

export const consumermenu = [
    headingMain,
    Dashboard,
    ViewRequest,
    RequestDisclosure,
    RequestDispute
    // ManageSubscribers,
    // headingComponents,
    // Elements,
    // Forms,
    // Charts,
    // Tables,
    // Maps,
    // headingMore,
    // Pages,
    // Blog,
    // Ecommerce,
    // Extras
];
